import { normalizeString } from '@pbk/utils';
import { useMemo } from 'react';
const defaultFilterOptions = (options, searchValue) => options.filter(({ text }) => normalizeString(text).includes(normalizeString(searchValue)));
export const useComboboxMatches = ({ filterOptions = defaultFilterOptions, options, searchValue, value, }) => {
    // Map to access values quicker than using find during option filtering bellow
    const optionValueToOptionMap = useMemo(() => options.reduce((acc, curr) => {
        acc[curr.value] = curr;
        return acc;
    }, {}), [options]);
    const matches = useMemo(() => {
        if (!searchValue)
            return options;
        const filteredOptions = filterOptions(options, searchValue);
        const selectedOption = value ? optionValueToOptionMap[value] : undefined;
        if (!selectedOption)
            return filteredOptions;
        // Radix Select does not work if we don't render the selected item, so we make sure to include it in the list of matches.
        const selectedOptionExistsInFilteredOptions = filteredOptions.some((option) => option.value === selectedOption.value);
        if (selectedOptionExistsInFilteredOptions)
            return filteredOptions;
        return [...filteredOptions, selectedOption];
    }, [filterOptions, optionValueToOptionMap, options, searchValue, value]);
    return matches;
};
